// Keep browser-wide client instrumentation lightweight. Client JS errors are
// captured by GlobalErrorReporter -> the owned `js_error` beacon, which avoids
// shipping the browser error SDK on every route.
export function onRouterTransitionStart() {}
